import get from 'lodash.get';

const getZendeskWidgetUrl = (rootState) => get(rootState, 'config.common.zendesk.widget_url', '');

export default getZendeskWidgetUrl;
